import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'redux-form';
import { LoginForm } from '../LoginForm/LoginForm';

const propTypes = {
    name: PropTypes.string,
    component: PropTypes.string,
};

const defaultProps = {
    name: 'login',
};

function LoginFormSection({ name, ...rest }) {
    return (
        <FormSection name={name}>
            <LoginForm component={Fragment} {...rest} />
        </FormSection>
    );
}

LoginFormSection.propTypes = propTypes;
LoginFormSection.defaultProps = defaultProps;

export default LoginFormSection;
